import { v4 as uuidv4 } from 'uuid';

const SESSION_ID_KEY = 'sessionId';
const SESSION_LAST_ACTIVITY_KEY = 'sessionExpiration';
const SESSION_DURATION_MS = 30 * 60 * 1000; // 30 minutes

/**
 * Web-specific session tools using localStorage.
 * Mirrors the API of @medely/base sessionTools but without AsyncStorage dependency.
 */
export const sessionTools = {
  getOrUpdateSessionId: (onSessionCreate?: () => void): string => {
    const existingId = localStorage.getItem(SESSION_ID_KEY);
    const lastActivity = localStorage.getItem(SESSION_LAST_ACTIVITY_KEY);

    if (existingId && lastActivity) {
      const timeSinceLastActivity = Date.now() - Number(lastActivity);
      if (timeSinceLastActivity <= SESSION_DURATION_MS) {
        return existingId;
      }
    }

    // Create new session
    const newId = uuidv4();
    localStorage.setItem(SESSION_ID_KEY, newId);
    localStorage.setItem(SESSION_LAST_ACTIVITY_KEY, Date.now().toString());
    onSessionCreate?.();
    return newId;
  },

  recordActivity: (onSessionCreate?: () => void): void => {
    sessionTools.getOrUpdateSessionId(onSessionCreate);
    localStorage.setItem(SESSION_LAST_ACTIVITY_KEY, Date.now().toString());
  },

  getLastActivity: (): number | null => {
    const time = localStorage.getItem(SESSION_LAST_ACTIVITY_KEY);
    return time ? Number(time) : null;
  },
};
